import { sendGAEvent } from './ga.helpers';
import type { GAEventName } from './ga.types';

const SSO_ORIGIN_PAGE_ITEM_KEY = 'signup_funnel_sso_origin_page';

export type SignupFunnelPage = 'register' | 'login';
export type SignupFunnelMethod = 'google' | 'microsoft' | 'email';

type SignupFunnelEventParams = Readonly<{
  page?: SignupFunnelPage;
  method?: SignupFunnelMethod;
  result?: 'success' | 'error';
  errorCode?: string;
}>;

export const sendSignupFunnelEvent = (
  eventName: GAEventName,
  { page, method, result, errorCode }: SignupFunnelEventParams,
  onSent?: () => void,
) => {
  // GTM keeps data layer values between pushes, so every parameter is always set to stop values leaking from earlier events
  sendGAEvent(eventName, {
    page: page ?? null,
    method: method ?? null,
    result: result ?? null,
    error_code: errorCode ?? null,
  }, onSent);
};

// remembers which page started the SSO redirect, so the event sent after returning from the provider can report it
export const storeSsoOriginPage = (page: SignupFunnelPage) => {
  sessionStorage.setItem(SSO_ORIGIN_PAGE_ITEM_KEY, page);
};

export const popSsoOriginPage = (): SignupFunnelPage | undefined => {
  const page = sessionStorage.getItem(SSO_ORIGIN_PAGE_ITEM_KEY);
  sessionStorage.removeItem(SSO_ORIGIN_PAGE_ITEM_KEY);
  return page === 'register' || page === 'login' ? page : undefined;
};
